<template>
  <!--  管理员-员工管理-->
  <div class="main-css">
    <!--      标题-->
    <div class="title-css">{{ $t("staffManagement") }}</div>
    <div class="main-box">
      <!-- button 部分 -->
      <div class="line-button-box">
        <el-button class="button-css" @click="handleAddClick">{{
          $t("new")
        }}</el-button>
        <el-button class="button-css" @click="handleAlterClick">{{
          $t("changeState")
        }}</el-button>
        <el-button class="button-css" @click="deleteAdminInfo">{{
          $t("delete")
        }}</el-button>
      </div>
      <!--      表格部分-->
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          style="width: 95%"
          height="550"
          @selection-change="handleSelectionChange"
          @sort-change="changeTableSort"
          v-loading="loading"
          @cell-click="tableCellClick"
          :cell-class-name="
            ({ row, column, rowIndex, columnIndex }) => (
              (row.index = rowIndex), (column.index = columnIndex)
            )
          "
        >
          <el-table-column type="selection" width="45"> </el-table-column>
          <!-- ----------------------番号---------------------- -->
          <el-table-column
            prop="userId"
            label="番号"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("id") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.userId }}
            </template>
          </el-table-column>
          <!-- ----------------------氏名---------------------- -->
          <el-table-column
            prop="userName"
            label="氏名"
            :show-overflow-tooltip="true"
            width="120"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("name") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.userName"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.userName }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------所属機関---------------------- -->
          <el-table-column
            prop="institutionName"
            label="所属機関"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p class="operate">{{ $t("belongs") }}</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.institutionName }}
            </template>
          </el-table-column>
          <!-- ----------------------担当数---------------------- -->
          <el-table-column
            prop="numberOfResponsibilities"
            label="担当数"
            :sortable="'column'"
            width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p class="operate">{{ $t("numberOfCases") }}</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.casesNumber }}
            </template>
          </el-table-column>
          <!-- ----------------------ユーザーID---------------------- -->
          <el-table-column
            prop="emailAddress"
            label="ユーザーID"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("userID") }}</p>
              <el-input
                v-model="searchData4"
                size="mini"
                placeholder="Search"
                @input="inputSearch"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.emailAddress"
                  @blur="tableCellInputBlur"
                  size="mini"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.emailAddress }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------登録日付---------------------- -->
          <el-table-column
            prop="createTime"
            label="登録日付"
            width="225"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("registerDay") }}</p>
              <div class="dataTimeChangeCss">
                <el-date-picker
                  v-model="time1"
                  type="datetime"
                  :placeholder="$t('registerDayselsect')"
                  class="data-timer-picker"
                  @blur="dataTimeChange"
                  @change="pickerChangeFn(time1)"
                  format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
              </div>
            </template>
            <template slot-scope="scope">
              {{ scope.row.createTime.substring(0, 10) }}
            </template> </el-table-column
          >>
          <!-- ----------------------最新修正日付---------------------- -->
          <el-table-column
            prop="updateTime"
            label="最新修正日付"
            :show-overflow-tooltip="true"
            width="110"
          >
            <template slot="header">
              <p class="operate">{{ $t("lastUpdataDay") }}</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.updateTime.substring(0, 10) }}
            </template>
          </el-table-column>
          <!-- ----------------------最新ログイン---------------------- -->
          <el-table-column
            prop="logindate"
            label="最新ログイン"
            width="110"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p class="operate">{{ $t("lastLogin") }}</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.loginDate.substring(0, 10) }}
            </template>
          </el-table-column>
          <!-- ----------------------権限---------------------- -->
          <el-table-column
            prop="authority"
            label="権限"
            width="160"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("limit") }}</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.roleName }}
            </template>
          </el-table-column>
          <!-- ----------------------IP---------------------- -->
          <el-table-column prop="ip" label="IP" :show-overflow-tooltip="true">
            <template slot="header">
              <p class="operate">IP</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.ip }}
            </template>
          </el-table-column>
          <!-- ----------------------状態---------------------- -->
          <el-table-column
            prop="userStatus"
            label="状態"
            width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("status") }}</p>
              <div class="el-dropdown-css-1">
                <el-dropdown @command="handleCommandDrop">
                  <span class="el-dropdown-link">
                    {{ stateItemName === "" ? "All" : stateItemName
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      :command="item.code"
                      v-for="(item, index) in stateList"
                      :key="index"
                      >{{ item.name }}
                    </el-dropdown-item>
                    <el-dropdown-item command="del">{{
                      $t("cancel")
                    }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.userStatus_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpuserStatus_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-- --------------------------操作-------------------------- -->
          <el-table-column
            prop="address"
            label="操作"
            align="center"
            fixed="right"
          >
            <template slot="header">
              <p class="operate">{{ $t("operate") }}</p>
            </template>
            <template slot-scope="scope">
              <button class="save-button" @click="handleSaveClick(scope.row)">
                {{ $t("save") }}
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- ------------------------状态变更的dialog------------------------ -->
      <div>
        <el-dialog title="状态变更" :visible.sync="dialogIsShow" width="30%">
          <div class="change-name-css" v-if="stateChange[0]">
            {{ $t("name") }}:{{ stateChange[0].userName }}
          </div>
          <el-form :model="form" style="margin-left: 100px;">
            <el-form-item label="状态选择">
              <el-select v-model="form.region" placeholder="请选择状态">
                <el-option
                  :label="item.name"
                  :value="item.code"
                  v-for="(item, index) in stateList"
                  :key="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">{{
              $t("cancel")
            }}</el-button>
            <el-button type="primary" @click="stateSure">{{
              $t("confirm")
            }}</el-button>
          </div>
        </el-dialog>
      </div>

      <!-- --------------------------新增dialog-------------------------- -->
      <div>
        <el-dialog title="新增" :visible.sync="addDialogVisible" width="30%">
          <div class="add-dialog-css">
            <div class="img-add-dialog-css" @click="toGetImg">
              <div class="add-icon" v-if="imgUrlAv === ''">
                <i class="el-icon-plus"></i>
              </div>
              <div class="add-icon" v-if="imgUrlAv !== ''">
                <img :src="imgUrl" alt="" />
              </div>
            </div>
            <p class="img-title">{{ $t("selectAvatar") }}</p>
            <el-form :model="addForm">
              <el-form-item label="姓名">
                <el-input v-model="addForm.name" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="邮箱">
                <el-input
                  v-model="addForm.emailAddress"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="密码">
                <el-input
                  v-model="addForm.password"
                  autocomplete="off"
                  type="password"
                ></el-input>
              </el-form-item>
              <el-form-item label="确认密码">
                <el-input
                  v-model="addForm.insurePassword"
                  autocomplete="off"
                  type="password"
                ></el-input>
              </el-form-item>
              <el-form-item label="选择角色">
                 <el-radio-group v-model="addForm.institution">
                   <el-radio label="medicalinstitution">医疗机构</el-radio>
                   <el-radio label="educationalinstitution">教育机构</el-radio>
                 </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="addDialogClose">{{ $t("cancel") }}</el-button>
            <el-button type="primary" @click="addAdminInfoData">{{
              $t("confirm")
            }}</el-button>
          </span>
        </el-dialog>
      </div>
      <!--      分页部分-->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="totalItem"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  batchDeleteInfoAdmin,
  stateChangesInfoAdmin,
  getDateItem,
  fuzzyQueryUserInfoAdmin,
  addAdminInfo,
  addUser,
  medicalAndEducationUserQuery,
  getUrlFromOSS,
  updateAdminInfoAdmin
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";
export default {
  name: "adminStaffManagement",
  components: {},
  data() {
    return {
      time1: "",
      imgUrlAv: "",
      tableData: [],
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      loading: false,
      totalItem: 0,
      idList: [],
      dialogIsShow: false,
      form: {
        region: ""
      },
      stateChange: [], //更改状态
      stateList: [], //状态数据字典
      stateCode: null, //模糊查询状态码
      stateItemName: "",
      addDialogVisible: false,
      imgUrl: '',
      addForm: {
        name: "",
        emailAddress: "",
        password: "",
        insurePassword: "",
        institution:'medicalinstitution'
      },
      tableCellClickRowIndex: null, // 点击的单元格行索引
      tableCellClickColumnIndex: null, // 点击的单元格列索引
      stateItemNameShow: false,
      permissionList: [],
      permissionCode: "",
      permissionName: ""
    };
  },
  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem("language");
    console.log("语言选择为" + window.localStorage.getItem("language"));
    console.log("页面语言选择为" + this.language);
    this.getLanguage();
    // 平台管理员用户全部查询 list
    this.allAdminInfo();
    //状态list获取
    this.stateListGet();
    // 权限list获取
    this.permissionListGet();
    this.getuserRights();
    this.getuserStatusChange();
  },
  computed: {},

  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        // 平台管理员用户全部查询 list
        this.allAdminInfo();
        //状态list获取
        this.stateListGet();
        // 权限list获取
        this.permissionListGet();
        this.getuserRights();
        this.getuserStatusChange();
      }
    },
    //单元格获取焦点
    tableCellClick(row, column, cell, event) {
      this.tableCellClickRowIndex = row.index;
      this.tableCellClickColumnIndex = column.index;
    },
    // 单元格失去焦点
    tableCellInputBlur(row, event, column) {
      this.tableCellClickRowIndex = null;
      this.tableCellClickColumnIndex = null;
    },

    //data -time 选择
    dataTimeChange() {
      console.log(this.time1);
      this.time1 = this.timeJs(this.time1);
      console.log(this.time1);
      this.inputSearch();
    },
    timeJs(date) {
      //获取年份
      var y = date.getFullYear();
      //获取月份  返回0-11
      var m = date.getMonth() + 1;
      // 获取日
      var d = date.getDate();
      //获取星期几  返回0-6   (0=星期天)
      var w = date.getDay();
      //星期几
      var ww = " 星期" + "日一二三四五六".charAt(date.getDay());
      //时
      var h = date.getHours();
      //分
      var minute = date.getMinutes();
      //秒
      var s = date.getSeconds();
      //毫秒
      var sss = date.getMilliseconds();

      if (m < 10) {
        m = "0" + m;
      }
      if (d < 10) {
        d = "0" + d;
      }
      if (h < 10) {
        h = "0" + h;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (s < 10) {
        s = "0" + s;
      }
      if (sss < 10) {
        sss = "00" + sss;
      } else if (sss < 100) {
        sss = "0" + sss;
      }
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },
    //清空时间
    pickerChangeFn(value) {
      if (value === null) {
        this.time1 = "";
        this.allAdminInfo();
      }
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "numberOfResponsibilities") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) =>
              a["numberOfResponsibilities"] - b["numberOfResponsibilities"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) =>
              b["numberOfResponsibilities"] - a["numberOfResponsibilities"]
          );
        }
      }
    },
    //选择行数据
    handleSelectionChange(val) {
      console.log(val);
      this.idList = [];
      for (var i = 0; i < val.length; i++) {
        this.idList.push(val[i].userId);
      }
      this.stateChange = val;
    },
    handleCommandDropOther(val) {
      console.log(val);
      for (var i = 0; i < this.permissionList.length; i++) {
        if (this.permissionList[i].code == val) {
          this.permissionCode = val;
          this.permissionName = this.permissionList[i].name;
        }
      }
    },
    //状态下拉框
    handleCommandDrop(val) {
      this.stateCode = val;
      for (var i = 0; i < this.stateList.length; i++) {
        if (this.stateList[i].stateCode === val) {
          this.stateItemName = this.stateList[i].name;
        }
      }
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.allAdminInfo();
    },
    // 新增 信息
    handleAddClick() {
      console.log(1);
      this.addDialogVisible = true;
    },
    // 新增dialog close
    addDialogClose() {
      this.addDialogVisible = false;
      this.addForm.name = "";
      this.addForm.emailAddress = "";
      this.addForm.password = "";
      this.addForm.insurePassword = "";
      this.addForm.institution = "educationalinstitution";
      this.imgUrlAv = "";
      this.imgUrl = ''
    },
    // 状态变更
    handleAlterClick() {
      if (this.stateChange.length === 1) {
        this.dialogIsShow = true;
      } else if (this.stateChange.length > 1) {
        this.$message({
          message: this.$t("OnlyOneMessageSelected"),
          type: "warning"
        });
      } else if (this.stateChange.length < 1) {
        this.$message({
          message: this.$t("selectLeastOneMessage"),
          type: "warning"
        });
      }
    },
    // 修改判断
    handleSaveClick(row) {
      if (row.emailAddress && row.userName) {
        var fakeInfo = {
          emailAddress: row.emailAddress,
          userId: row.userId,
          userName: row.userName
        };
        this.upDateInfo(fakeInfo);
      } else if (!row.emailAddress && row.userName) {
        var fakeInfo = {
          emailAddress: row.emailAddress,
          userId: row.userId,
          userName: row.userName
        };
        this.upDateInfo(fakeInfo);
      } else if (row.emailAddress && !row.userName) {
        var fakeInfo = {
          emailAddress: row.emailAddress,
          userId: row.userId,
          userName: row.userName
        };
        this.upDateInfo(fakeInfo);
      } else if (!row.emailAddress && !row.userName) {
        this.$message({
          message: this.$t("informationNotModified"),
          type: "warning"
        });
      }
    },
    // 修改
    upDateInfo(row) {
      var fakeInfo = row;
      console.log(fakeInfo);
      updateAdminInfoAdmin(fakeInfo)
        .then(res => {
          console.log("-----修改信息接口-----");
          console.log(res);
          if (res.data.code === "A0160") {
            console.log(1);
            this.$message({
              message: this.$t("emailRegistered"),
              type: "warning"
            });
          } else if (res.data.code === "A0000") {
            this.allAdminInfo();
            this.$message({
              message: this.$t("successfullyModified"),
              type: "success"
            });
          } else {
            this.$message.error(this.$t("failToEdit"));
          }
        })
        .catch(res => {});
    },

    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
        console.log(7);
      } else if (command === "b") {
        this.pageSize = 15;
        console.log(15);
      } else if (command === "c") {
        this.pageSize = 20;
        console.log(20);
      } else if (command === "d") {
        this.pageSize = 25;
        console.log(25);
      }
      this.currentPage = 1;
      this.allAdminInfo();
    },
    // 平台管理员用户全部查询 list
    allAdminInfo() {
      var that = this;
      const fakeInfo = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      medicalAndEducationUserQuery(fakeInfo)
        .then(res => {
          console.log("----管理员用用户列表信息----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.tableData = aesFecInfo.data;
            this.totalItem = aesFecInfo.total;
            // for (var i = 0; i < this.tableData.length; i++) {
            //   this.fromOSSGetUrl(this.tableData[i].avatar, i)
            // }
          }
        })
        .catch(res => {
          console.log("----管理员用用户列表信息----");
          console.log(res);
        });
    },
    //回显图片
    fromOSSGetUrl(url, i) {
      var fakeInfo = {
        message: url
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          console.log("-----回显图片接返回参数-----");
          console.log(res);
          if (res.data.code === "200 OK") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.tableData[i].avatar = aesFecInfo.message;
          }
        })
        .catch(res => {
          console.log("-----回显图片接返回参数-----");
          console.log(res);
        });
    },
    //删除
    deleteAdminInfo() {
      if (this.idList.length < 1) {
        this.$message({
          message: this.$t("selectLeastOneMessage"),
          type: "warning"
        });
      } else {
        const fakeInfo = {
          listId: this.idList
        };
        batchDeleteInfoAdmin(fakeInfo)
          .then(res => {
            console.log("-----删除后管理平台用户接口-----");
            console.log(res);
            if (res.data.code === "A0000") {
              this.$message({
                message: this.$t("successfullyDeleted"),
                type: "success"
              });
              this.allAdminInfo();
            } else {
              this.$message.error(this.$t("failedToDelete"));
            }
          })
          .catch(res => {
            console.log("-----删除后管理平台用户接口-----");
            console.log(res);
          });
      }
    },
    //状态数据字典获取
    stateListGet() {
      this.getLanguage();
      const fakeInfo = {
        dataItem: this.userStatus
      };
      getDateItem(fakeInfo)
        .then(res => {
          console.log("-----变更状态数据字典获取-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.stateList = aesFecInfo.data;
          }
        })
        .catch(res => {
          console.log("-----变更状态数据字典获取-----");
          console.log(res);
        });
    },
    // 权限下拉框（数据字典获取）
    permissionListGet() {
      const fakeInfo = {
        dataItem: this.userRights
      };
      getDateItem(fakeInfo)
        .then(res => {
          console.log("-----权限下拉框数据字典获取-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.permissionList = aesFecInfo.data;
          }
        })
        .catch(res => {
          console.log("-----变更状态数据字典获取-----");
          console.log(res);
        });
    },
    //状态修改
    stateSure() {
      const fakeInfo = {
        userId: this.stateChange[0].userId,
        userStatus: this.form.region
      };
      stateChangesInfoAdmin(fakeInfo)
        .then(res => {
          console.log("-----状态修改接口-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            this.$message({
              message: this.$t("successfullyModified"),
              type: "success"
            });
            this.allAdminInfo();
            this.dialogIsShow = false;
          } else {
            this.$message.error(this.$t("failToEdit"));
          }
        })
        .catch(res => {
          console.log("-----状态修改接口-----");
          console.log(res);
        });
    },
    //模糊查询
    inputSearch(e) {
      const fakeInfo = {
        createTimeIn: this.time1,
        createTimeOut: "",
        emailAddress: this.searchData4,
        ip: "",
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        updateTimeIn: "",
        updateTimeOut: "",
        userId: this.searchData1,
        userName: this.searchData2,
        userStatus: this.stateCode
      };
      fuzzyQueryUserInfoAdmin(fakeInfo)
        .then(res => {
          console.log("-----模糊查询接口-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.tableData = aesFecInfo.data;
            this.totalItem = aesFecInfo.total;
          }
        })
        .catch(res => {
          console.log("-----模糊查询接口-----");
          console.log(res);
        });
    },
    //生成上传图片控件
    toGetImg() {
      let inputElement = null;
      if (inputElement === null) {
        // 生成文件上传的控件
        inputElement = document.createElement("input");
        inputElement.setAttribute("type", "file");
        inputElement.style.display = "none";

        if (window.addEventListener) {
          inputElement.addEventListener("change", this.uploadFile, false);
        } else {
          inputElement.attachEvent("onchange", this.uploadFile);
        }
        document.body.appendChild(inputElement);
      }
      inputElement.click();
    },
    //上传图片
    uploadFile(el) {
      const that = this;
      if (el && el.target && el.target.files && el.target.files.length > 0) {
        const files = el.target.files[0];
        const isLt2M = files.size / 1024 / 1024 < 1;
        const size = files.size / 1024 / 1024;
        // 判断上传文件的大小
        if (!isLt2M) {
          this.$message.error("上传头像图片大小不能超过 1MB!");
        } else if (files.type.indexOf("image") === -1) {
          //如果不是图片格式
          // this.$dialog.toast({ mes: '请选择图片文件' });
          this.$message.error(this.$t("selectImage"));
        } else {
          const reader = new FileReader(); // 创建读取文件对象
          reader.readAsDataURL(el.target.files[0]); // 发起异步请求，读取文件
          reader.onload = function() {
            const formData = new FormData();
            formData.append("file", files); // 可以传到后台的数据
            axios
              .post("/api/modules-parent/upload/uploadPictureToOSS", formData, {
                headers: {
                  //头部参数
                  "Content-Type": "multipart/form-data",
                  token: localStorage.getItem("token")
                }
              })
              .then(function(res) {
                //请求成功
                if (res.data.code === "200 OK") {
                  console.log("-----上传图片参数-----");
                  console.log(res);
                  const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
                  console.log(aesFecInfo);
                  that.imgUrlAv = aesFecInfo.path;
                  that.imgUrl =  aesFecInfo.url
                }
              })
              .catch(function(error) {
                //请求失败
                console.log(error);
              });
          };
        }
      }
    },
    //新增
    addAdminInfoData() {
      if(this.imgUrlAv === ""){
        this.$message({
          message: this.language === "CN"? '请上传头像!': '画像をアップロードしてください!',
          type: "warning"
        });
        return
      }
      if(this.emailAddress === ""){
        this.$message({
          message: this.language === "CN"? '请上传头像!': '画像をアップロードしてください!',
          type: "warning"
        });
        return
      }
      if(this.password === ""){
        this.$message({
          message: this.language === "CN"? '密码不能为空!': 'パスワードは空欄にしない!',
          type: "warning"
        });
        return
      }
      if(this.name === ""){
        this.$message({
          message: this.language === "CN"? '姓名不能为空!': '名前を空欄にしてはいけない!',
          type: "warning"
        });
        return
      }
       if(this.insurePassword === ""){
        this.$message({
          message: this.language === "CN"? '请确认密码!': 'パスワードを確認してください!',
          type: "warning"
        });
        return
      }
      if(this.institution === ""){
        this.$message({
          message: this.language === "CN"? '角色不能为空!': '役割が空回りしてはいけない!',
          type: "warning"
        });
        return
      }
      //  if (
      //   this.imgUrlAv === "" ||
      //   this.addForm.emailAddress === "" ||
      //   this.addForm.password === "" ||
      //   this.addForm.name === "" ||
      //   this.addForm.insurePassword === ""||
      //   this.addForm.institution === ""
      // ) {
      //   this.$message({
      //     message: this.$t("enterAllInformation"),
      //     type: "warning"
      //   });
      // } else
      if (this.addForm.password !== this.addForm.insurePassword) {
        this.$message({
          message: this.$t("inconsistentPasswordEnteredTwice"),
          type: "warning"
        });
      } else {
        var fakeInfo = {
          avatar: this.imgUrlAv,
          emailAddress: this.addForm.emailAddress,
          password: this.addForm.password,
          userName: this.addForm.name,
          institution: this.addForm.institution
        };
        addUser(fakeInfo)
          .then(res => {
            console.log("--------新增接口--------");
            console.log(res);
            if (res.data.code === "A0160") {
              this.$message({
                message: this.language === "CN"? '邮箱已被注册!': 'メールボックスは登録済み!',
                type: "warning"
              });
              // this.addDialogVisible = false;
            }else if (res.data.code === "A0000") {
              this.$message({
                message: this.$t("releaseSuccess"),
                type: "success"
              });
              this.addDialogVisible = false;
            } else {
              this.$message.error(this.$t("releaseFail"));
            }
          })
          .catch(res => {
            console.log("--------新增接口--------");
            console.log(res);
          });
      }
    },

    //获取userRights下拉
    handleCommanduserRights(evt) {
      this.userRightsCode = evt.code;
      this.userRightsName = evt.name;
    },
    //获得语言
    getLanguage() {
      if (this.language === "CN") {
        this.userRights = "userRights";
        this.userStatus = "userStatus";
        this.userStatusChange = "userStatusChange";
        this.dataItem = "jobReviewStatus";
      } else {
        this.userRights = "jpuserRights";
        this.userStatus = "jpuserStatus";
        this.userStatusChange = "jpuserStatusChange";
        this.dataItem = "jpjobReviewStatus";
      }
    },
    getuserStatusChange() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.userStatusChange
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据userStatusChange--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.userStatusChangeData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.userStatusChangeData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },

    getuserRights() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.userRights
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据userRights--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.userRightsData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.userRightsData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    }
  }
};
</script>

<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  position: relative;
}

.dataTimeChangeCss {
  border: 1px solid #efefef;
  margin-top: 6px;
}

.dataTimeChangeCss /deep/ .el-input__inner {
  width: 200px;
  height: 30px;
}

.dataTimeChangeCss /deep/ .el-date-editor {
  width: 200px;
  height: 30px;
}

.dataTimeChangeCss /deep/ .el-input__icon {
  line-height: 30px;
}

.dataTimeChangeCss /deep/ .el-input__icon:after {
  margin-right: 6px !important;
}

.main-box {
  margin-top: 0px;
  width: 100%;
  padding: 0 40px 0 80px;
  box-sizing: border-box;
}

.title-css {
  /*标题样式*/
  font-family: "lucida sans unicode", "lucida grande", sans-serif;
  /*字体*/
  color: #686868;
  /*字体颜色*/
  font-size: 2em;
  /*字体大小*/
  text-align: center;
  /*对齐方式*/
  line-height: 76px;
  /*行间距*/
  margin-top: 10px;
}

.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  margin-top: 25px;
  margin-left: 40px;
}

.el-dropdown-css-1 /deep/ .el-dropdown {
  width: 80px !important;
  margin-top: 5px;
}

.el-dropdown-css-2 /deep/ .el-dropdown {
  width: 120px !important;
  margin-top: 6px;
}

.button-css {
  width: 90px;
  height: 35px;
  background: #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  margin-right: 25px;
  text-align: center;
}

.search {
  width: 100%;
  height: 25px;
  display: flex;
}

.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}

.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}

.search /deep/ .el-input__icon {
  line-height: 24px;
}

.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}

.table {
  width: 100%;
  height: 520px;
  margin-top: 10px;
}

.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
  text-align: center;
}

.operate {
  height: 51px;
}

.table /deep/ .el-dropdown {
  width: 60px;
}

.table-img-css {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.el-dropdown-link {
  /*下拉框*/
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}

.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.table /deep/ .el-table__cell {
  position: relative;
  text-align: center;
}

.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -4px;
  right: -48px;
  width: 67px;
}

.save-button {
  width: 69px;
  height: 36px;
  background: #fff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 10px;
  color: #51abff;
  cursor: pointer;
  margin-right: 10px;
}

.pagination {
  width: 95%;
  height: 50px;
  margin-top: 60px;
}

.pagination-main {
  float: right;
  margin-right: 10px;
  display: flex;
}

.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}

.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}

.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}

.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}

.change-name-css {
  text-align: center;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 600;
}

.add-dialog-css {
  width: 100%;
  height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.img-add-dialog-css {
  width: 80px;
  height: 80px;
  overflow: hidden;
  border-radius: 50%;
  border: 1px solid #686868;
  cursor: pointer;
}

.img-add-dialog-css img {
  width: 80px;
  height: 80px;
}

.add-icon {
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 54px;
  font-size: 34px;
  font-weight: 700;
}

.img-title {
  height: 26px;
}

.add-dialog-css /deep/ .el-form {
  width: 250px;
}

.add-dialog-css /deep/ .el-form-item {
  margin-bottom: 5px;
}

.el-date-box {
  width: 150px;
  height: 30px;
  margin-top: 5px;
}

.el-date-box /deep/ .el-date-editor {
  width: 150px;
}

.el-date-box /deep/ .el-input__inner {
  width: 140px !important;
  border: 1px solid #efefef;
  border-radius: 4px;
  width: 145px;
  height: 30px;
}

.el-date-box /deep/ .el-input__icon {
  line-height: 30px;
}

/*  */
</style>



// WEBPACK FOOTER //
// src/pages/adminStaffManagement/index.vue